  <div *ngIf="statusLabels[status]" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px" [ngClass]="statusLabels[status]?.color" class="label">
    <mat-icon [matTooltip]="statusLabels[status]?.tooltipMsg"
    [matTooltipClass]="'status-tooltip-'+statusLabels[status]?.icon">{{statusLabels[status]?.icon}}</mat-icon>
    <span>{{statusLabels[status]?.label}}</span>
  </div>
  <span *ngIf="!statusLabels[status]">{{status}}</span>